export default {
  name: 'LocalePicker',
  props: ['value', 'disabled', 'noLocaleOption'],
  data () {
    return {
      content: this.value
    }
  },
  computed: {
    localeOptions () {
      const options = this.$store.getters.getConfigOptions('locales', this.$i18n.locale);
      if (this.noLocaleOption) {
        options.unshift({ code: '' });
      } else if (this.value === null && options.length > 0) {
        this.content = options[0].code;
        this.updateValue();
      }
      return options;
    }
  },
  methods: {
    updateValue () {
      this.$emit('input', this.content)
    }
  }
}
